import { yupResolver } from '@hookform/resolvers/yup';
import { Box, IconButton, IconButtonProps } from '@mui/material'
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import CustomText from 'components/common/CustomText/CustomText';
import CustomDialog from 'components/dialogs/CustomDialog';
import CustomFormSelect from 'components/inputs/CustomFormSelect/CustomFormSelect';
import { useGetRegistriesList } from 'hooks/useLookups';
import { useExportCasesToRegistry } from 'hooks/useRegistries';
import RegistriesIcon from 'icons/RegistriesIcon'
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { snackbarService } from 'services/snackbarService';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles'
import * as yup from 'yup';

const validationSchema = yup.object({
  registry_id: yup.string().required('Registry is required'),
})

interface Props {
  ids: number[];
  onClose: () => void;
}

export default function ExportToRegistriesButton({ ids, onClose }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  const globalStyles = useGlobalStyles();

  const { data: registriesList } = useGetRegistriesList();

  const { mutate: exportMutation, isLoading } = useExportCasesToRegistry(
    () => {
      setOpen(false);
      setTimeout(() => onClose(), 100);
      snackbarService.showSnackbar("Cases have been exported successfully", "success");
    },
    () => { },
  )

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      registry_id: '',
    },
  });

  const {
    handleSubmit,
    formState: { isValid, errors },
  } = methods;


  const onSubmit = (data: any) => {
    exportMutation({
      registryId: data.registry_id,
      procedureIds: ids,
    });
  }

  const onDialogClose = () => {
    setOpen(false);
    onClose?.();
  }

  return (
    <FormProvider {...methods}>
      <IconButton
        className={globalStyles.popoverButtonContainer}
        onClick={(e) => {
          setOpen(true);
        }}
      >
        <Box className={globalStyles.popoverIconContainer}>
          <RegistriesIcon size={15} />
        </Box>
        <CustomText text="Export to Registries" ml="5px" color={colors.black} />
      </IconButton>

      <CustomDialog
        open={open}
        title={'Export to Registries'}
        message={'Choose a registry to export cases to!'}
        onClose={onDialogClose}
        content={<Box mt={3}>
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <CustomFormSelect
              name='registry_id'
              options={registriesList || []}
              required
              floatingLabel='Registries'
              placeholder='Select registry'
              error={errors.registry_id}
            />
            <Box my={1.5}>
              <CustomButton
                fullWidth
                text='Export'
                height={40}
                type='submit'
                loading={isLoading}
                disabled={!isValid}
              />
            </Box>

          </Box>

        </Box>}
        buttons={[]}
      />
    </FormProvider>
  )
}
